import { SET_MAINTENANCE } from '../mutations.type'

const state = {
  isMaintenance: false
}

const getters = {
  isMaintenance (state) {
    return state.isMaintenance
  }
}

const mutations = {
  [SET_MAINTENANCE] (state, isMaintenance) {
    if (isMaintenance) {
      window.app.$router.push({ name: 'maintenance' })
    } else if (state.isMaintenance) {
      window.app.$router.push({ name: 'home' })
    }
    state.isMaintenance = isMaintenance
  }
}

export default {
  state,
  mutations,
  getters
}
